import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

var ReactDOM = require('react-dom')

import utils from './utils.js';
import { Pace } from './Components/Layout/Pace.jsx';
import { CasinoLink } from './Components/Layout/CasinoLink.jsx';
import { Footer } from './Components/Layout/Footer.jsx';
import { PrekiniSamoiskljucenje } from './Components/Layout/PrekiniSamoiskljucenje.jsx';
import { Notifikacija } from './Components/Layout/Notifikacija.jsx';
import { Obavijest } from './Components/Layout/Obavijest.jsx';
import { PopUpInfo } from './Components/Layout/PopUpInfo.jsx';
import { Menu } from './Components/Layout/Menu.jsx';
import { BottomNavigationBar } from './Components/Layout/BottomNavigationBar.jsx';
import MoreMenu from './Components/Layout/MoreMenu.jsx';
import SearchOverlay from './Components/Layout/SearchOverlay.jsx';
import { NetworkError } from './Components/Layout/NetworkError.jsx';

import { NotFound } from './Pages/All/NotFound.jsx';

import { Home } from './Pages/Casino/Home.jsx';
import { CasinoDownload } from './Pages/Casino/CasinoDownload.jsx';
import Providers from './Pages/Casino/Providers.jsx';
import Themes from './Pages/Casino/Themes.jsx';
import { Login } from './Pages/All/Login.jsx';
import { AccountBonuses } from './Pages/All/AccountBonuses.jsx';

import { AccountTransactions } from './Pages/All/AccountTransactions.jsx';
import { AccountGameProviderDetails } from './Pages/All/AccountGameProviderDetails.jsx';
import { AccountGameDetails } from './Pages/All/AccountGameDetails.jsx';
import { AccountGames } from './Pages/All/AccountGames.jsx';
import { AccountFreeGames } from './Pages/All/AccountFreeGames.jsx';
import { Account } from './Pages/All/Account.jsx';
import { AccountObavijesti } from './Pages/All/AccountObavijesti.jsx';
import { Account2 } from './Pages/All/Account2.jsx';

import { InfoPranjeNovca } from './Pages/All/InfoPranjeNovca.jsx';
import { Info } from './Pages/All/Info.jsx';
import { Jackpot } from './Pages/Casino/Jackpot.jsx';

import { Winners } from './Pages/Casino/Winners.jsx';
import { BonusesHalloween } from './Pages/Casino/BonusesHalloween.jsx';
import { BonusesValentinovo } from './Pages/Casino/BonusesValentinovo.jsx';

import { FirstDepositBonus } from './Pages/Casino/FirstDepositBonus.jsx';
import { BonusesHappyHour } from './Pages/Casino/BonusesHappyHour.jsx';
import { BonusesLastManStanding } from './Pages/Casino/BonusesLastManStanding.jsx';
import { Bonuses3 } from './Pages/Casino/Bonuses3.jsx';
import Bonuses from './Pages/Casino/Bonuses.jsx';
import { EgyptQuest } from './Pages/Casino/EgyptQuest.jsx';
import { BonusesCasinoMaraton } from './Pages/Casino/BonusesCasinoMaraton.jsx';
import { BonusesCasinoSprint } from './Pages/Casino/BonusesCasinoSprint.jsx';
import { DropsAndWins } from './Pages/Casino/DropsAndWins.jsx';
import { SuperKlub } from './Pages/Casino/SuperKlub.jsx';
import { SpinsSplash } from "./Pages/Casino/SpinsSplash.jsx";
import BonusesSuperAvantura from './Pages/Casino/BonusesSuperAvantura.jsx';
import ZimskaSuperBomba from './Pages/Casino/ZimskaSuperBomba.jsx';
import MjesecnaSuperBomba from './Pages/Casino/MjesecnaSuperBomba.jsx';

import { OpcaPravila } from './Pages/Casino/Pravila/OpcaPravila.jsx';
import { OdgovornoIgranje } from './Pages/Casino/Pravila/OdgovornoIgranje.jsx';
import { ZastitaPrivatnosti } from './Pages/Casino/Pravila/ZasitaPrivatnosti.jsx';
import { PolitikaKolacica } from './Pages/Casino/Pravila/PolitikaKolacica.jsx';
import { PravilaSuperkluba } from './Pages/Casino/Pravila/PravilaSuperkluba.jsx';
import { PravilaSuperspina } from './Pages/Casino/Pravila/PravilaSuperspina.jsx';
import { ObavijestOObradiOsobnihPodataka } from './Pages/Casino/Pravila/ObavijestOObradiOsobnihPodataka.jsx';
import { Plus18 } from './Pages/Casino/Pravila/Plus18.jsx';
import { PostavkePrivatnosti } from './Components/Account/PostavkePrivatnosti.jsx';
import Tvrtki from './Pages/Casino/Pravila/Tvrtki.jsx';
import { Certifikati } from './Pages/Casino/Pravila/Certifikati.jsx';
import { Faq } from './Pages/Casino/Pravila/Faq.jsx';

import { InfoLanding } from './Pages/LandingPages/InfoLanding.jsx';

import { ReloadBonus } from './Pages/Casino/ReloadBonus.jsx';
import { PokerHome } from './Pages/Poker/PokerHome.jsx';
import { PokerDownload } from './Pages/Poker/PokerDownload.jsx';
import { PokerLive } from './Pages/Poker/PokerLive.jsx';
import { PokerRoom } from './Pages/Poker/Live/PokerRoom.jsx';
import { PokerClassic } from './Pages/Poker/Live/PokerClassic.jsx';
import { PokerClassicMini } from './Pages/Poker/Live/PokerClassicMini.jsx';
import { PokerFestival } from './Pages/Poker/Live/PokerFestival.jsx';

import { PokerTournaments } from './Pages/Poker/PokerTournaments.jsx';
import { PokerBonuses } from './Pages/Poker/PokerBonuses.jsx';
import { CasinoUtrke } from './Pages/Casino/CasinoUtrke.jsx';
import { CasinoUtrka } from './Pages/Casino/CasinoUtrka.jsx';
import { CasinoIzazovi } from './Pages/Casino/CasinoIzazovi.jsx';
import { Chat } from './Pages/Chat/Chat.jsx';
import { KontaktPage } from './Pages/Casino/KontaktPage.jsx';
import { PopisIgara } from './Pages/Casino/PopisIgara.jsx';

import BonusesCasinoSuperskok from "./Pages/Casino/BonusesCasinoSuperskok.jsx";

import { AllPromotions } from './Pages/Casino/AllPromotions.jsx';

import BonusesCasinoSuperbomba from "./Pages/Casino/BonusesCasinoSuperbomba.jsx";

import '../content/style-src.less'
import { CookiePopUp } from "./Components/Layout/CookiePopUp.jsx";
import { CookiePolicy } from "./Components/Layout/CookiePolicy.jsx";
import VipPage from "./Pages/Casino/Vip/VipPage.jsx";
import AccountSuperKlub from "./Components/Account/AccountSuperKlub.jsx";
import GameInfo from "./Components/Game/GameInfo.jsx";
import AccountSuperSpin from "./Components/Account/AccountSuperSpin.jsx";
import SuperStory from "./Pages/Casino/SuperStory.jsx";
import BonusesCasinoSuperKisa from "./Pages/Casino/BonusesCasinoSuperKisa.jsx";
import BonusesCasinoCashback from "./Pages/Casino/BonusesCasinoCashback.jsx";
import ThemeSelection from "./Pages/All/ThemeSelection.jsx";
import SuperPredah from "./Pages/All/SuperPredah.jsx";
import InGameWidget from "./Components/Game/InGameWidget.jsx";
import { WebSocketProvider } from './Components/Game/WSContext.jsx'

class App extends React.Component {
    constructor(props) {
        super(props);

        // dohvatimo lokalne linkove i sortiramo ih prema duljini, tako da se napravi filtiranje prvo prema poddomenama onda tek prema domenama
        var productPaths = Object.keys(casino.config.menu).map(x => casino.config.menu[x].url).filter(x => x.indexOf('http') != 0).sort((a, b) => b.length - a.length);
        var isIos = casino.utils.isIos();
        casino.config.canIUseWebP = casino.utils.canIUseWebP();
        casino.config.gameImagesUrl = 'https://cdn.supersport.hr/casino/gameimages/';

        //force currency through url query parameter
        let forceCurrency = casino.utils.getUrlParameters("in_eur")["in_eur"] != undefined ? decodeURI(casino.utils.getUrlParameters("in_eur")["in_eur"]) : null;
        if (forceCurrency) {
            localStorage.setItem('activeCurrency', +forceCurrency == 1 ? 'eur' : 'kn');
            let url = window.location.href;
            let n = url.indexOf('?');
            history.pushState({}, null, url.substring(0, n != -1 ? n : url.length));
        }

        this.state = {
            user: null,
            userChecked: false,
            sesijaId: null,
            showMenu: false,
            showMoreMenu: false,
            showLoading: false,
            menu: casino.config.menu,
            footer: casino.config.footer,
            iznosSkriven: JSON.parse(localStorage.getItem(this.consts.iznosSkriven)) || false,
            novoBannerSkriven: JSON.parse(localStorage.getItem(this.consts.headerBannerSkriven)) || false,
            networkError: false,
            productPaths: productPaths,
            ugaseneIgrePoruka: null,
            showSearch: false,
            showPopUp: false,
            popUpCode: null,
            brojNotifikacija: 0,
            brojStorya: 0,
            stories: false,
            important: false,
            device: {
                isIos: isIos
            },
            jackpots: [],
            jackpotsUkupno: null,
            noveIgreBanner: null,
            androidDlBannerIsVisible: true,
            disablePopUpBtn: false,
            maradonaIgreBanner: null,
            autoShowRandomGame: false,
            refreshRandonGame: false,
            showCookiePopUp: false,
            popUpParams: null,
            bonuses: [
                {
                    code: 'casino-superbomba-fazi-2023-09',
                    titleSmall: 'Fazi SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(4000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 23.09. u 00:00 i traje do kraja 26.09.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/fazi-2023-09',
                    isActive: true
                },
                {
                    code: 'casino-superskok-egt-2023-09',
                    titleSmall: 'EGT Digital SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 18.09. u 00:00 do kraja 22.09. i odigraj EGT Digital igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(10000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/egt-2023-09',
                    isActive: true
                },
                {
                    code: 'casino-superbomba-playson-2023-09',
                    titleSmall: 'Playson SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 11.09. u 00:00 i traje do kraja 16.09.! Uključi se odmah i zavrti bilo koju igru od Playson providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/playson-2023-09',
                    isActive: false
                },
                {
                    code: 'casino-superskok-fazi-2023-09',
                    titleSmall: 'SuperSkok vikend uz Fazi',
                    titleBig: casino.utils.numberWithCurrencyFromated(3000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 08.09. u 00:00 do kraja 10.09. i odigraj odabrane Fazi igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(3000) + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/fazi-2023-09',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-egt-digital-2023-09',
                    titleSmall: 'EGT Digital SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 04.09. u 00:00 i traje do kraja 07.09.! Uključi se odmah i zavrti bilo koju igru od EGT Digital providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/egt-digital-2023-09',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-supercasino-2023-08',
                    titleSmall: 'SuperCasino SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(150000, 'EUR'),
                    titleMid: '',
                    description: '3000 bombi smo podijelili, novih 1000 je spremno! Nova runda starta 24.8. u podne i traje do 31.8. do 11:59 sati. Zaigraj bilo koju igru u SuperCasinu uz minimalan ulog od 0,30 € jer možda upravo tebe čeka bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/supercasino-2023-08-04',
                    isActive: false
                },
                {
                    code: 'casino-superskok-egt-2023-08',
                    titleSmall: 'EGT Digital SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 21.08. u 00:00 do kraja 25.08. i odigraj EGT Digital Casino igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(8000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/egt-2023-08',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-supercasino-2023-08',
                    titleSmall: 'SuperCasino SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(150000, 'EUR'),
                    titleMid: '',
                    description: '2000 bombi smo podijelili, novih 1000 je spremno! Nova runda starta 17.8. u podne i traje do 23.8. do 11:59 sati. Zaigraj bilo koju igru u SuperCasinu uz minimalan ulog od 0,30 € jer možda upravo tebe čeka bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/supercasino-2023-08-03',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-supercasino-2023-08',
                    titleSmall: 'SuperCasino SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(150000, 'EUR'),
                    titleMid: '',
                    description: '1000 bombi smo podijelili, novih 1000 je spremno! Nova runda starta 11.8. u podne i traje do 16.8. do 11:59 sati. Zaigraj bilo koju igru u SuperCasinu uz minimalan ulog od 0,30 € jer možda upravo tebe čeka bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/supercasino-2023-08-02',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-supercasino-2023-08',
                    titleSmall: 'SuperCasino SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(150000, 'EUR'),
                    titleMid: '',
                    description: 'Prva SuperBomba utrka starta 05.08. u 12:00 i traje do 10.08. u 12:00! Uključi se odmah i zavrti bilo koju igru u SuperCasinu. Možda se upravo tebi nasmješi bomba s najvećom nagradom! Sljedeća bomba kreće nakon samo jednog dana odmora i tako sve do kraja kolovoza! Spremi se! ',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/supercasino-2023-08-01',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-egt-digital-2023-08',
                    titleSmall: 'EGT Digital SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 31.07. u 00:00 i traje do 04.08. u 12:00! Uključi se odmah i zavrti bilo koju igru od EGT Digital providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/egt-digital-2023-08',
                    isActive: false
                },
                {
                    code: 'synot-superskok-2023',
                    titleSmall: 'Synot SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(6000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 28.7. u 00:00 do kraja 31.7. i zavrti odabrane Synot igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(6000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/synot-superskok-2023',
                    isActive: false
                },
                {
                    code: 'superklub',
                    titleSmall: 'Program vjernosti',
                    titleBig: 'SuperKlub',
                    titleMid: '',
                    description: 'SuperKlub je program vjernosti kojim nagrađujemo naše vjerne igrače za njihovu aktivnost. Uključi se u igru, rješavaj izazove, skupljaj Supere i zamijeni ih za nagrade!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/superklub',
                    isActive: true
                },
                {
                    code: 'casino-superbomba-pragmatic',
                    titleSmall: 'Pragmatic Play SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 24.07. u 00:00 i traje do kraja 27.07.! Uključi se odmah i zavrti bilo koju igru od Pragmatic Play providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/pragmatic-2023-07',
                    isActive: false
                },
                {
                    code: 'casino-superskok-playson',
                    titleSmall: 'Playson SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 17.7. u 00:00 do kraja 23.7. i zavrti Playson igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(10000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/playson-superskok-2023',
                    isActive: false
                },
                {
                    code: 'spinomenal-casino-sprint',
                    titleSmall: 'Spinomenal Sprint',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'Sprint počinje 10.7. - uključi se i ti! Dođi u online SuperCasino i izvrti minimalno ' + casino.utils.numberWithCurrencyFromated(100, 'EUR') + ' svaki dan. Sprintaju svi koji tako zaigraju, a nagradu od ' + casino.utils.numberWithCurrencyFromated(10000, 'EUR') + ' dijele svi koja ga završe.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-sprint/spinomenal-casino-sprint',
                    isActive: false
                },
                {
                    code: 'drops-and-wins',
                    titleSmall: 'Drops & Wins',
                    titleBig: casino.utils.numberWithCurrencyFromated(500000, 'EUR'),
                    titleMid: 'Svaki tjedan',
                    description: 'Zaigraj Pragmatic Play Drops & Wins jer svakom vrtnjom imaš šansu osvojiti jednu od dnevnih nagrada iz nagradnog fonda od ' + casino.utils.numberWithCurrencyFromated(35000, 'EUR') + ', a uporni mogu osvojiti i turnirsku nagradu iz fonda od ' + casino.utils.numberWithCurrencyFromated(255000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/drops-and-wins',
                    isActive: true
                },
                {
                    code: 'evoplay-superskok-2023',
                    titleSmall: 'Evoplay SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 3.7. u 00:00 do kraja 6.7. i zavrti odabrane Evoplay igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(8000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/evoplay-superskok-2023',
                    isActive: false
                },
                {
                    code: 'rodjendanski-superskok',
                    titleSmall: 'Rođendanski SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(30000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 23.6. u 00:00 do kraja 25.6. i odigraj bilo koju igru uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(30000) + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/rodjendanski-superskok',
                    isActive: true,
                    layout: 1,
                    backgroundColor: 'loyalty-orange-1',
                    image: '/CasinoMobile/content/images/promotions/skok.png',
                    prize: casino.utils.numberWithCurrencyFromated(5000, 'EUR'),
                    startDate: '2023-06-29',
                    endDate: '2023-06-31',
                },
                {
                    code: 'casino-superbomba-amusnet',
                    titleSmall: 'Amusnet SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 19.06. u 00:00 i traje do kraja 25.06.! Uključi se odmah i zavrti odabrane igre Amusnet providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/amusnet-2023-06',
                    isActive: true,
                    layout: 2,
                    backgroundColor: 'loyalty-pink',
                    image: '/CasinoMobile/content/images/promotions/ilustracijaL2.png',
                    prize: casino.utils.numberWithCurrencyFromated(25000, 'EUR'),
                    startDate: '2023-06-25',
                    endDate: '2023-06-31',
                    started: true
                },
                {
                    code: 'egt-digital-casino-sprint',
                    titleSmall: 'EGT Digital Sprint',
                    titleBig: casino.utils.numberWithCurrencyFromated(3000, 'EUR'),
                    titleMid: '',
                    description: 'Sprint počinje u četvrtak 15.6. - uključi se i ti! Dođi u online SuperCasino i izvrti ' + casino.utils.numberWithCurrencyFromated(80, 'EUR') + '. Sprintaju svi koji tako zaigraju, a nagradu od ' + casino.utils.numberWithCurrencyFromated(7000, 'EUR') + ' dijele svi koja ga završe.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-sprint/egt-digital-casino-sprint',
                    isActive: true,
                    layout: 1,
                    backgroundColor: 'loyalty-orange-2',
                    image: '/CasinoMobile/content/images/promotions/mobile.png',
                    prize: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    startDate: '2023-07-01',
                    endDate: '2023-07-08',
                },
                {
                    code: 'casino-superbomba-pragmatic',
                    titleSmall: 'Pragmatic Play SuperBomba',
                    description: 'SuperBomba utrka starta 12.06. u 12:00 i traje do kraja 17.06.! Uključi se odmah i zavrti bilo koju igru od Pragmatic Play providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/pragmatic-2023-06',
                    layout: 3,
                    backgroundColor: 'purple',
                    image: '/CasinoMobile/content/images/promotions/pcelicaL3.png',
                    startDate: '2023-06-12',
                    endDate: '2023-06-27',
                    dailyBonus: false,
                    prize: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                },
                {
                    code: 'casino-superbomba-egt-digital-2023-06',
                    titleSmall: 'EGT Digital SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(7000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 08.06. u 00:00 i traje do kraja 11.06.! Uključi se odmah i zavrti bilo koju igru od EGT Digital providera. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/egt-digital-2023-06',
                    layout: 1,
                    backgroundColor: 'light-blue',
                    image: '/CasinoMobile/content/images/promotions/zeko.png',
                    started: false,
                    startDate: '2023-06-20',
                    endDate: '2023-06-25',
                    dailyBonus: true,
                    prize: casino.utils.numberWithCurrencyFromated(7000, 'EUR'),
                },
                {
                    code: 'casino-sprint',
                    titleSmall: 'Playson Sprint',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'Sprint počinje u ponedjeljak 19.6. - uključi se i ti! Dođi u online SuperCasino i izvrti ' + casino.utils.numberWithCurrencyFromated(100, 'EUR') + '. Sprintaju svi koji tako zaigraju, a nagradu od ' + casino.utils.numberWithCurrencyFromated(10000, 'EUR') + ' dijele svi koja ga završe.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-sprint/playson-casino-sprint',
                    layout: 1,
                    backgroundColor: 'dark-blue',
                    image: '/CasinoMobile/content/images/promotions/last.png',
                    startDate: '2023-06-10',
                    endDate: '2023-06-14',
                    dailyBonus: true,
                    prize: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                },
                {
                    code: 'casino-superskok-pragmatic-play-2023-05',
                    titleSmall: 'Pragmatic Play SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(6000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 22.5. u 00:00 do kraja 26.5. i odigraj Pragmatic Play igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(6000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/pragmatic-play-2023-05',
                    layout: 3,
                    backgroundColor: 'yellow',
                    image: '/CasinoMobile/content/images/promotions/pcelicaL3.png',
                    started: false,
                    startDate: '2023-06-20',
                    endDate: '2023-06-22',
                    dailyBonus: true,
                    prize: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                },
                {
                    code: 'casino-superskok-seven-mojos-2023-05',
                    titleSmall: '7Mojos SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(6000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 18.5. u 00:00 do kraja 21.5. i odigraj 7Mojos igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(6000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/seven-mojos-2023-05',
                    layout: 2,
                    backgroundColor: 'pink',
                    image: '/CasinoMobile/content/images/promotions/ilustracijaL2.png',
                    startDate: '2023-06-10',
                    endDate: '2023-06-11',
                    dailyBonus: false,
                    prize: casino.utils.numberWithCurrencyFromated(5000, 'EUR'),
                },
                {
                    code: 'casino-superbomba-playson-2023-05',
                    titleSmall: 'Playson SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 17.05. u 00:00 i traje do kraja 21.05.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/playson-2023-05',
                    layout: 2,
                    backgroundColor: 'violet',
                    image: '/CasinoMobile/content/images/promotions/ilustracijaL2.png',
                    startDate: '2023-06-15',
                    endDate: '2023-06-21',
                    dailyBonus: false,
                    prize: casino.utils.numberWithCurrencyFromated(7500, 'EUR'),
                },
                {
                    code: 'casino-superskok-egt-2023-05',
                    titleSmall: 'EGT Digital SuperSkok',
                    titleBig: casino.utils.numberWithCurrencyFromated(7000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 2.5. u 00:00 do kraja 7.5. i odigraj EGT Digital igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(7000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/egt-2023-05',
                    isActive: false
                },
                {
                    code: 'teh4bet-casino-sprint',
                    titleSmall: 'Tech4Bet Sprint',
                    titleBig: casino.utils.numberWithCurrencyFromated(8000, 'EUR'),
                    titleMid: '',
                    description: 'Sprint počinje u ponedjeljak 24.4. - uključi se i ti! Dođi u online SuperCasino i izvrti ' + casino.utils.numberWithCurrencyFromated(80, 'EUR') + '. Sprintaju svi koji tako zaigraju, a nagradu od ' + casino.utils.numberWithCurrencyFromated(8000, 'EUR') + ' dijele svi koja ga završe.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-sprint/tech4bet-casino-sprint',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-egt-digital-2023-04',
                    titleSmall: 'EGT Digital SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(7000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 17.04. u 00:00 i traje do kraja 23.04.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/egt-digital-2023-04',
                    isActive: false
                },
                {
                    code: 'casino-sprint',
                    titleSmall: 'Casino Sprint',
                    titleBig: casino.utils.numberWithCurrencyFromated(6000, 'EUR'),
                    titleMid: '',
                    description: 'Sprint počinje u ponedjeljak 10.4. - uključi se i ti! Dođi u online SuperCasino i izvrti ' + casino.utils.numberWithCurrencyFromated(50, 'EUR') + '. Sprintaju svi koji tako zaigraju, a nagradu od ' + casino.utils.numberWithCurrencyFromated(6000, 'EUR') + ' dijele svi koja ga završe.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-sprint',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-uskrs',
                    titleSmall: 'Amusnet-SuperBomba Uskrs',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 03.04. u 00:00 i traje do kraja 10.04.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja blagdanska bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/uskrs-2023',
                    isActive: false
                },
                {
                    code: 'casino-superskok-fazi-2023-03',
                    titleSmall: 'SuperSkok uz Fazi',
                    titleBig: casino.utils.numberWithCurrencyFromated(6000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 27.03. u 00:00 do kraja 30.03. i odigraj Fazi igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(6000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/fazi-2023-03',
                    isActive: false
                },
                {
                    code: 'casino-superskok-amusnet-2023-03',
                    titleSmall: 'SuperSkok uz Amusnet',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 13.03. u 00:00 do kraja 17.03. i odigraj Amusnet igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(10000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/amusnet-2023-03',
                    isActive: false
                },
                {
                    code: 'casino-superskok-fazi-2023-02',
                    titleSmall: 'SuperSkok uz Fazi',
                    titleBig: casino.utils.numberWithCurrencyFromated(6000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 20.02. u 00:00 do kraja 26.02. i odigraj Fazi igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(6000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/fazi-2023-02',
                    isActive: false
                },
                {
                    code: 'casino-superskok-valentinovo',
                    titleSmall: 'SuperSkok uz EGT Digital',
                    titleBig: casino.utils.numberWithCurrencyFromated(7000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 10.02. u 00:00 do kraja 14.02. i odigraj EGT Casino igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(0.3, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(7000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/valentinovo',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-egt-digital-2023-01',
                    titleSmall: 'EGT Digital SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(7000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 10.01. u 12:00 i traje do kraja 15.01.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/egt-digital-2023-01',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-bozic',
                    titleSmall: 'Predbožićna SuperCasino SuperBomba od',
                    titleBig: casino.utils.numberWithCurrencyFromated(150000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 19.12. u 12:00 i traje do kraja 24.12.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja blagdanska bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/bozic',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-playngo',
                    titleSmall: 'Zaigraj novu blagdansku SuperBombu od',
                    titleBig: casino.utils.numberWithCurrencyFromated(50000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 13.12. u 12:00 i traje do kraja 18.12.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja blagdanska bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/playngo',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-fazi',
                    titleSmall: 'Zaigraj novu blagdansku SuperBombu od',
                    titleBig: casino.utils.numberWithCurrencyFromated(50000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 07.12. u 12:00 i traje do kraja 12.12.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja blagdanska bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/fazi',
                    isActive: false
                },
                {
                    code: 'casino-superbomba-egt-digital',
                    titleSmall: 'Zaigraj novu blagdansku SuperBombu od',
                    titleBig: casino.utils.numberWithCurrencyFromated(50000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba utrka starta 01.12. u 12:00 i traje do kraja 06.12.! Uključi se odmah i zavrti odabrane igre. Možda se upravo tebi dokotrlja blagdanska bomba s najvećom nagradom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba/egt-digital',
                    isActive: false
                },
                {
                    code: 'casino-superbomba',
                    titleSmall: 'Casino SuperBomba',
                    titleSmall2: 'Zaigraj utrku vrijednu',
                    titleBig: casino.utils.numberWithCurrencyFromated(100000, 'EUR'),
                    titleMid: '',
                    description: 'SuperBomba počinje 25.11. u 12:00 i traje do kraja 28.11.! Fitilj gori, vrijeme curi, zato se brzo uključi i zaigraj za bomba nagrade!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superbomba',
                    isActive: false
                },

                {
                    code: 'casino-fazi-superskok',
                    titleSmall: 'SuperSkok uz Fazi',
                    titleBig: casino.utils.numberWithCurrencyFromated(50000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 10.10.2022. do kraja 16.10.2022. i odigraj Fazi Casino igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(2, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(50000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/fazi',
                    isActive: false
                },
                {
                    code: 'casino-evoplay-superskok',
                    titleSmall: 'SuperSkok uz Evoplay',
                    titleBig: casino.utils.numberWithCurrencyFromated(40000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 17.10.2022. do kraja 21.10.2022. i odigraj Evoplay Casino igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(2, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(40000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/evoplay',
                    isActive: false
                },
                {
                    code: 'casino-amusnet-superskok',
                    titleSmall: 'SuperSkok uz Amusnet',
                    titleBig: casino.utils.numberWithCurrencyFromated(80000, 'EUR'),
                    titleMid: '',
                    description: 'Zaigraj svaki dan od 11.11.2022. do kraja 20.11.2022. i odigraj Amusnet Casino igre uz minimalni ulog od ' + casino.utils.numberWithCurrencyFromated(2, 'EUR') + ' i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(80000, 'EUR') + '.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-superskok/amusnet',
                    isActive: false
                },
                {
                    code: 'halloween',
                    titleSmall: 'HALLOWEEN',
                    titleBigLeft: '2X',
                    titleBig: 'Bonus',
                    description: 'Udvostruči dobitak na Halloween utrci. Zaigraj jezive igre, sudjeluj u utrci te osvoji najveći pojedinačni dobitak, a mi ćemo ga udvostručiti.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/halloween',
                    isActive: false
                },
                {
                    code: 'valentinovo',
                    titleSmall: 'Valentinovo',
                    titleBigLeft: '2X',
                    titleBig: 'Bonus',
                    description: 'Traje 4 dana - Od petka 00:00 do ponedjeljka u 20:00 sati igraj odabrane igre. Nagrađujemo 200 najupornijih, a poduplat ćemo i najveći dobitak na spinu!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/valentinovo',
                    isActive: false
                },
                {
                    code: 'bonus-dobrodoslice',
                    titleSmall: 'Za nove igrače',
                    titleBig: '300 FREE',
                    titleMid: 'SPINOVA',
                    description: 'Pridruži se dokazano najboljem Casinu jer te čeka poklon dobrodošlice - 100 besplatnih vrtnji bez potrebe za uplatom!',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/first-deposit',
                    isActive: true
                },
                {
                    code: 'last-man-standing',
                    titleSmall: 'Last Man Standing',
                    titleBig: casino.utils.numberWithCurrencyFromated(10000, 'EUR'),
                    titleMid: 'Bonusa',
                    description: 'Svaki mjesec sudjeluj u novom ratu. Uključi se u sve borbe, preživi svaku od njih. Izdrži sve borbe do kraja i sudjeluj u podjeli primamljivih nagrada. Odigraj, budi uporan i osvoji.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/last-man-standing',
                    isActive: false
                },
                {
                    code: 'casino-maraton-uskrs',
                    titleSmall: 'Casino Maraton',
                    titleBig: casino.utils.numberWithCurrencyFromated(350000, 'EUR'),
                    titleMid: 'Nagradni fond',
                    description: 'Zaigraj svaki dan od 05.04.2022. do 18.04.2022. i izvrti minimalno ' + casino.utils.numberWithCurrencyFromated(800, 'EUR') + ' kroz Casino igre i sudjeluj u podjeli nagrade od ' + casino.utils.numberWithCurrencyFromated(350000, 'EUR') + '. Najbolji Super Skakači dijele ' + casino.utils.numberWithCurrencyFromated(100000, 'EUR') + ', a ostalih se ' + casino.utils.numberWithCurrencyFromated(250000, 'EUR') + ' dijeli na jednake dijelove svim sudionicima koji su stigli do kraja maratona.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-maraton',
                    isActive: false
                },
                {
                    code: 'happy-hour',
                    titleSmall: 'Happy Hour utrka',
                    titleBig: casino.utils.numberWithCurrencyFromated(1000, 'EUR'),
                    titleMid: 'Svaki dan',
                    description: 'Svakog dana, jednom ili više puta dnevno radimo malu utrku u trajanju jednog sata. Kvalificiraj se u prvoj polovici sata i zavrti sretni spin u drugoj polovici te odnesi nagradu.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/happy-hour',
                    isActive: false
                },
                {
                    code: 'casino-sprint',
                    titleSmall: 'Casino Sprint',
                    titleBig: casino.utils.numberWithCurrencyFromated(100000, 'EUR'),
                    titleMid: '',
                    description: 'Sprint počinje u utorak 15.3. - uključi se i ti! Dođi u online SuperCasino i izvrti ' + casino.utils.numberWithCurrencyFromated(800, 'EUR') + '. Sprintaju svi koji tako zaigraju, a nagradu od ' + casino.utils.numberWithCurrencyFromated(100000, 'EUR') + ' dijele svi koja ga završe.',
                    buttonText: 'Saznaj više',
                    buttonAction: 'promotions/casino-sprint',
                    isActive: false
                },
                //{
                //    code: 'casino-maraton',
                //    titleSmall: 'Casino Maraton',
                //    titleBig: '350.000kn',
                //    titleMid: 'Nagradni fond',
                //    description: 'Zaigraj svaki dan od 05.04.2022. do 18.04.2022. i izvrti minimalno 800 kn kroz Casino igre i sudjeluj u podjeli nagrade od 350.000 kn. Najbolji Super Skakači dijele 100.000 kn, a ostalih se 250.000 kn dijeli na jednake dijelove svim sudionicima koji su stigli do kraja maratona.',
                //    buttonText: 'Saznaj više',
                //    buttonAction: 'promotions/casino-maraton',
                //    isActive: false
                //}

                //},
                // {
                //     code: 'casino-superskok',
                //     titleSmall: 'SuperSkok Utrka',
                //     titleBig: '50.000kn',
                //     titleMid: '',
                //     description: 'Zaigraj svaki dan od 15.06.2022. do 19.06.2022. i odigraj Casino igre uz minimalni ulog od 2kn i sudjeluj u podjeli nagrade od 50.000 kn.',
                //     buttonText: 'Saznaj više',
                //     buttonAction: 'promotions/casino-superskok',
                //     isActive: false
                // },

            ],
            popUpCloseOnOutsideClick: true,
            tabCategoryId: null,
            filterSelectedCategories: [],
            filterSelectedThemes: [],
            filterSelectedProviders: [],
            filteredGames: [],
            historyFilters: [],
            filterSelectedSpecialFilters: [],
            brands: {},
            igraOtvorena: false
        };

        this.getHomePath = this.getHomePath.bind(this);
        this.onNetworkError = this.onNetworkError.bind(this);
        this.fetchUser = this.fetchUser.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.toggleMoreMenu = this.toggleMoreMenu.bind(this);
        this.showSearch = this.showSearch.bind(this);
        this.showLoading = this.showLoading.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.pozzitoStarted = this.pozzitoStarted.bind(this);
        this.toggleSakrijIznos = this.toggleSakrijIznos.bind(this);
        this.sakrijNovoBanner = this.sakrijNovoBanner.bind(this);
        this.getBaseName = this.getBaseName.bind(this);
        this.toggleFavoritGame = this.toggleFavoritGame.bind(this);
        this.sakrijObavijest = this.sakrijObavijest.bind(this);
        this.renderMenu = this.renderMenu.bind(this);
        this.isMenuLinkActive = this.isMenuLinkActive.bind(this);
        this.getMainClass = this.getMainClass.bind(this);
        this.unpackGamesList = this.unpackGamesList.bind(this);
        this.showPopUp = this.showPopUp.bind(this);
        this.fetchJackpots = this.fetchJackpots.bind(this);
        this.closeAndroidDlBanner = this.closeAndroidDlBanner.bind(this);
        this.getNotifikacije = this.getNotifikacije.bind(this);
        this.setNotifikacijeData = this.setNotifikacijeData.bind(this);
        this.disablePopUpBtn = this.disablePopUpBtn.bind(this);
        this.saveCategories = this.saveCategories.bind(this);
        this.showCookiePopUp = this.showCookiePopUp.bind(this);
        this.autoShowRandomGame = this.autoShowRandomGame.bind(this);
        this.refreshRandomGame = this.refreshRandomGame.bind(this);
        this.disablePopUpOutsideClick = this.disablePopUpOutsideClick.bind(this);
        this.setTabCategory = this.setTabCategory.bind(this);
        this.setActiveFilters = this.setActiveFilters.bind(this);
        this.filterGames = this.filterGames.bind(this);
        this.setHistoryFilters = this.setHistoryFilters.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }

    consts = {
        headerBannerSkriven: "novoBannerSkriven-ssopl-jesen-2017",
        iznosSkriven: "iznosSkriven"
    }

    getHomePath(location, url) {
        var productPaths = this.state.productPaths;
        var currentUrl = location.pathname;
        var currentPath = null;
        productPaths.map(x => {
            if (!currentPath)
                // Only consider single-segment paths (product roots like /, /poker),
                // skip multi-segment leaf pages like /pravila/faq
                if (currentUrl.indexOf(x) == 0 && x.indexOf('/', 1) === -1)
                    currentPath = x;
        });
        return ((currentPath || '/') + (url || '')).replace('//', '/');
    }
    componentDidMount() {
        //da se ne console.loga na produkciji
        if (window.location.hostname === "mcasino.supersport.hr") {
            console.log = () => { }
        }

        var that = this;
        casino.repos.base.networkErrorsListener = this.onNetworkError;

        this.fetchUser(true);


        window.removeEventListener("focus", this.fetchUser);
        window.addEventListener("focus", this.fetchUser);

        this.fetchJackpots();
        this.jackpotsTimer = setInterval(() => {
            that.fetchJackpots();
        }, 120 * 1000);

        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        let ssgame = sessionStorage.getItem('game_finished_gtm');
        if (ssgame) {
            var data = JSON.parse(ssgame);

            if (!data.demo)
                casino.repos.casinoGameOptimoveRepo.post({ igraID: data.gameId, nadimak: data.user });

            casino.utils.createGoogleTagManagerEvent(data);
            sessionStorage.removeItem('game_finished_gtm');
        }

        if (casino.utils.getCookie("cookie_consent") == null) {
            this.setState({ showCookiePopUp: true });
        }
        casino.config.showPopUpFromOutside = this.showPopUp;
        casino.config.getNotifications = () => {
            this.setState({ igraOtvorena: true });
            this.getNotifikacije();
        }

        //Load scripts - cookie policy
        if (casino.utils.getCookie('marketing') == '1') {
            //Load Frosmo
            //casino.utils.loadFrosmoScript();

            //Check Affiliate URL link
            //Commented out, see https://supersport.atlassian.net/browse/SCCM-1848?focusedCommentId=57653
            //var vm_param = casino.utils.getURLParameter('wm');
            //if (vm_param !== casino.utils.getCookie("affiliate")) {
            //    if (vm_param !== undefined && vm_param !== 'undefined' && vm_param !== '') {
            //        casino.utils.deleteCookie("affiliate");
            //        casino.utils.setCookie("affiliate", vm_param, 30);
            //    }
            //}
        }

        if (casino.utils.getCookie('analytic') == '1') {
            //Load GTM
            casino.utils.loadGTMScript();
            //Load CrazyEgg
            /*casino.utils.loadCrazyEggSctipt();*/
            casino.utils.loadMSClaritySctipt();
        } else {
            casino.utils.removeGTMScript();
        }

        //if (casino.utils.getCookie("cookie_consent") != null && casino.utils.getCookie("visitor") == null) {
        //    casino.utils.setCookie("visitor", casino.utils.uuidv4(), 365);
        //}

        var storedFilters = JSON.parse(localStorage.getItem("stored-filters"));
        if (storedFilters) {
            this.setState({ historyFilters: storedFilters });
        }

        //GA360
        var browserScreenResolution = window.screen.width + 'x' + window.screen.height;
        var browserOrientation = window.matchMedia("(orientation: portrait)").matches ? 'PORTRAIT' : 'LANDSCAPE';

        casino.utils.createGoogleTagManagerEvent({
            'browserInformation': {
                'browser.userAgent': casino.config.userAgent,
                'page.culture': casino.config.cultureInfo,
                'page.frontend': "mobile",
                'page.domain': "https://mcasino.supersport.hr/",
                'page.medium': "mobile web",
                'browser.orientation': browserOrientation,
                'browser.screenResolution': browserScreenResolution
            }
        });
    }

    onNetworkError(error) {
        // Dodatna zaštita: ako je dokument skriven, ne prikazuj error screen.
        if (document.hidden) {
            console.warn('NetworkError suppressed (document hidden)');
            return;
        }
        this.setState({ networkError: true });
    }

    handleVisibilityChange() {
        if (document.hidden) {
            // Stranica je u pozadini — pauziramo jackpots polling
            clearInterval(this.jackpotsTimer);
            this.jackpotsPaused = true;
        } else {
            // Stranica je ponovno vidljiva — restartamo polling
            if (this.jackpotsPaused) {
                this.jackpotsPaused = false;
                var that = this;
                this.fetchJackpots();
                this.jackpotsTimer = setInterval(() => {
                    that.fetchJackpots();
                }, 120 * 1000);
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.jackpotsTimer);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.dataPromiseNotifikacije) this.dataPromiseNotifikacije.cancel();
    }

    fetchUser(fromAppComponentDidMounth = false) {
        var result = /[^/]*$/.exec(window.location.pathname)[0];
        if (fromAppComponentDidMounth instanceof Event && (result == "superspin" || result == "superklub")) return null;

        this.showLoading(true);
        var that = this;

        return casino.repos.sessionRepo.get()
            .then((sesija) => {
                that.updateUser(sesija.igrac, sesija.sesijaId);

                if (fromAppComponentDidMounth)
                    //Google tag manager
                    if (sesija.igrac) {
                        casino.utils.createGoogleTagManagerEvent({
                            'event': 'userID',
                            'user_id': sesija.igrac.token,
                            'accountID': sesija.igrac && sesija.igrac.publicID || ""
                        });
                    }

                //GA360
                casino.utils.createGoogleTagManagerEvent({
                    'userInformation': {
                        'user.profile.accountID': sesija.igrac && sesija.igrac.publicID || "",
                        'user.profile.bal': sesija.igrac != null && sesija.igrac.casinoRaspolozivoZaIsplatu != null ? sesija.igrac.casinoRaspolozivoZaIsplatu : 0,
                        'user.profile.currency': "EUR",
                        'user.profile.country': "HR",
                        'user.session.geoIPCountry': casino.config.iPAddress,
                        'user.hasPositiveBalance': sesija.igrac && sesija.igrac.casinoRaspolozivoZaIsplatu > 0 ? true : false,
                        'user.isAuthenticated': sesija.igrac ? true : false,
                        'user.isExisting': sesija.igrac ? true : false
                    }
                });
            })
            .then(() => that.showLoading(false));
    }

    fetchJackpots() {
        // Ne radi API pozive ako je dokument skriven
        if (document.hidden) return;

        var that = this;

        casino.repos.jackpotsRepo.list()
            .then((jackpots) => {
                that.setState({ jackpots: jackpots });
            });

        casino.repos.jackpotsUkupnoRepo.get()
            .then((res) => {
                that.setState({ jackpotsUkupno: res });
            });
    }
    showMenu(value) {
        if (this.state.showMenu != value)
            this.setState({
                showMenu: value
            });
    }
    toggleMoreMenu(value) {
        if (this.state.showMoreMenu != value) {
            this.setState({
                showMoreMenu: value,
                showMenu: false
            });
        }
    }
    showSearch(value, searchValue, focus = true) {
        // if (searchValue)
        //     localStorage.setItem("casino-mobile-search", searchValue);

        if (this.state.showSearch != value)
            this.setState({
                showSearch: value,
                showSearchFocus: focus
            });
    }
    showPopUp(value, code, callbackFn, popUpParams = null) {
        if (!value)
            window.localStorage.setItem(this.state.popUpCode, 1);

        if (this.state.showPopUp != value)
            this.setState({
                showPopUp: value,
                popUpCode: code || this.state.popUpCode,
                pupUpCallback: callbackFn,
                popUpParams: popUpParams
            });
    }

    disablePopUpOutsideClick() {
        this.setState({ popUpCloseOnOutsideClick: false });
    }
    disablePopUpBtn(value) {
        this.setState({ disablePopUpBtn: value });
    }
    autoShowRandomGame(value) {
        this.setState({ autoShowRandomGame: value });
    }
    refreshRandomGame(value) {
        this.setState({ refreshRandomGame: value });
    }
    showLoading(value) {
        if (this.state.showLoading != value)
            this.setState({
                showLoading: value
            });
    }
    showCookiePopUp(value) {
        if (value != null && !value) {
            this.setState({ showCookiePopUp: value });
        } else {
            if (casino.utils.getCookie("cookie_consent") == null) {
                this.setState({ showCookiePopUp: true });
            }
        }
    }
    updateUser(user, sesijaId) {
        this.setState({
            user: user,
            userChecked: true
        });

        const savedMode = localStorage.getItem("darkModeStrategy");
        const darkMode = user?.darkMode;

        const modeToByte = (mode) => {
            switch (mode) {
                case "light": return 1;
                case "dark": return 2;
                case "system": return 3;
                default: return 1;
            }
        };
        const byteToMode = (byte) => {
            switch (byte) {
                case 1: return "light";
                case 2: return "dark";
                case 3: return "system";
                default: return "light";
            }
        };

        if (!!savedMode) { // ls
            if (!!user) {
                const preferedMode = modeToByte(savedMode);
                if (!darkMode) {
                    casino.repos.igracDarkModeRepo(preferedMode); // sync to server
                } else localStorage.setItem("darkModeStrategy", byteToMode(darkMode));
            }
        } else if (!!user) { // !ls
            localStorage.setItem("darkModeStrategy", byteToMode(darkMode));
            casino.repos.igracDarkModeRepo(modeToByte(darkMode)); // sync to server
        }

        // ako se sesija ne pošalje ne radi ništa, ako je null onda postavi null
        if (sesijaId !== undefined) {
            this.setState({
                sesijaId: sesijaId
            });
        }

        // ako je prijavljen u pozzito a napravio logout
        if (!user && this._pozzitoStarted)
            try {
                this._pozzitoStarted = false;
                BeeBeeate.widget.destroy(this._pozzitoInstance);
            } catch (error) {
                console.log(error);
            }

        if (!user)
            this.setState({ notifikacije: null, brojNotifikacija: 0 });
    }
    pozzitoStarted(started, instance) {
        if (arguments.length) {
            this._pozzitoStarted = started;
            this._pozzitoInstance = instance;
        }

        return this._pozzitoStarted;
    }
    toggleSakrijIznos() {
        var newState = !this.state.iznosSkriven;
        localStorage.setItem(this.consts.iznosSkriven, JSON.stringify(newState));
        this.setState({
            iznosSkriven: newState
        });
    }
    sakrijNovoBanner() {
        localStorage.setItem(this.consts.headerBannerSkriven, JSON.stringify(true));
        this.setState({
            novoBannerSkriven: true
        });
    }
    closeAndroidDlBanner() {
        let expires = 1000 * 60 * 60 * 24 * 10; // 10 days

        let bannerClosed = casino.utils.getLocalStorageWithExpiry("android-dl-banner-is-closed");

        if (bannerClosed === null) {
            casino.utils.setLocalStorageWithExpiry("android-dl-banner-is-closed", true, expires);
        }
        this.setState({ androidDlBannerIsVisible: false });
    }
    getBaseName() {
        var baseHref = document.getElementsByTagName('base')[0].getAttribute("path");
        if (baseHref.lastIndexOf('/') == (baseHref.length - 1))
            baseHref = baseHref.substring(0, baseHref.length - 1);
        return baseHref;
    }
    toggleFavoritGame(game) {
        var user = this.state.user;
        var gameId = game.id;
        var indexOfGameId = user.favoriti.indexOf(gameId);
        if (indexOfGameId == -1) {
            user.favoriti.push(gameId);
            casino.repos.favoritesRepo.create(game);
        }
        else {
            user.favoriti.splice(indexOfGameId, 1);
            casino.repos.favoritesRepo.remove(game);
        }
        this.setState({ user: user });
    }
    sakrijObavijest(naziv) {
        var user = this.state.user;
        var indexOfObavijest = user.obavijesti.indexOf(naziv);
        if (indexOfObavijest != -1) {
            user.obavijesti.splice(indexOfObavijest, 1);
            casino.repos.obavijestiRepo.remove(naziv);
            this.setState({ user: user });
        }
    }

    renderMenu(activeOnlyWhenExact, tabletMenu = false) {
        var that = this;
        var localPaths = this.state.productPaths;
        var lightThemeActiveStyle = casino.utils.getCasinoTheme() !== "dark" ? { color: '#bc0d1a' } : undefined;

        return Object.keys(this.state.menu).map(function (text) {
            var item = that.state.menu[text];

            if (item.hideIos && that.state.device.isIos)
                return null;

            if (item.hideOnTabletMenu && tabletMenu)
                return null;

            if (item.url.toString().startsWith('http') || item.url.toString().startsWith('mailto')) {
                return (
                    <React.Fragment key={text}>
                        <li>
                            <CasinoLink href={item.url}>
                                {!item.imgIcon && <span className={"tablet-hidden " + item.icon}></span>}
                                {item.imgIcon && !item.superSpin && <div className="tablet-hidden super7_ico_box"><img src="content/images/assets/super7_ico.svg" alt="super7-ico" /></div>}
                                {/*{item.imgIcon && item.superSpin && <div className="tablet-hidden ic_superspin_menu"><img src="content/images/assets/ic_superspin_menu.svg" alt="ic_superspin_menu" /></div>}*/}
                                <span>{text}</span>
                            </CasinoLink>
                        </li>
                        <div style={{ 'clear': 'both' }} className="tablet-hidden"></div>
                        {item.borderBottom && <div className="divider tablet-hidden"></div>}
                    </React.Fragment>)
            }
            if (activeOnlyWhenExact) {
                return (
                    <React.Fragment key={casino.utils.nameToUrl(text)}>
                        <li>
                            <NavLink to={item.url} activeClassName="selected" activeStyle={lightThemeActiveStyle} exact onClick={() => that.showMenu(false)}>
                                <span className={"tablet-hidden " + item.icon}></span>
                                <span>
                                    {text}
                                    {item.borderBottom && <span className="new-badge">Novo</span>}
                                </span>

                            </NavLink>
                        </li>
                        <div style={{ 'clear': 'both' }} className="tablet-hidden"></div>
                        {item.borderBottom && <div className="divider tablet-hidden"></div>}
                    </React.Fragment>)
            }
            return (
                <li key={casino.utils.nameToUrl(text)}>
                    <NavLink to={item.url} activeClassName="selected" activeStyle={lightThemeActiveStyle} isActive={(match, location) => that.isMenuLinkActive(match, location, item.url, localPaths)}>
                        <span>{text}</span>
                    </NavLink>
                </li>)
        }).filter(x => !!x);
    }
    isMenuLinkActive(match, location, url, localPaths) {
        var currentUrl = location.pathname;
        var currentPath = null;
        localPaths.map(x => {
            if (!currentPath)
                if (currentUrl.indexOf(x) == 0)
                    currentPath = x;
        });

        return url == currentPath;
    }
    getMainClass(route) {
        var cssClass = ' ';

        // prikazi menu
        if (this.state.showMenu)
            cssClass += ' menu-shown';

        // prikazi search
        if (this.state.showSearch)
            cssClass += ' search-shown';

        // prikazi more menu
        if (this.state.showMoreMenu)
            cssClass += ' more-menu-shown';

        if (this.state.showPopUp)
            cssClass += ' popup-shown';

        //klasa novo-shown nam treba da složi visinu headera, a nakon toga se prikazje poruka koju smo sprogramirali
        //poruka-shown je automatska poruka koju prikazjemo ako neke igre nisu dostupne, ona ima najveću važnost

        //if (route.location.pathname.indexOf('/poker') >= 0
        //   && route.location.pathname.indexOf('/account') < 0
        //   && route.location.pathname.indexOf('/poker-reload') < 0)
        //   cssClass += ' novo-shown';

        //Android App - show download banner
        if (route.location.pathname.indexOf('/poker') < 0
            && route.location.pathname.indexOf('/account') < 0
            && route.location.pathname.indexOf('/poker-reload') < 0
            && !this.state.device.isIos
            && casino.utils.getLocalStorageWithExpiry('android-dl-banner-is-closed') == null)
            cssClass += ' android-download-shown';

        if (this.state.ugaseneIgrePoruka && route.location.pathname.indexOf('/poker') != 0)
            cssClass += ' poruka-shown novo-shown';

        return cssClass;
    }
    unpackGamesList(data) {
        // prihvati response od games - unutra kominacija igri + poruka o ugašenom provideru
        var poruka = data.ugaseneIgrePoruka || null;
        if (this.state.ugaseneIgrePoruka != poruka)
            this.setState({ ugaseneIgrePoruka: poruka });

        this.setState({ noveIgreBanner: data.noveIgreBanner, tags: data.tagovi, brands: data.brendovi, maradonaIgreBanner: data.maradonaIgreBanner });
        casino.casinoConstants.brands = data.brendovi;
        casino.casinoConstants.games = data.items;
        return data.items;
    }

    saveCategories(data) {
        casino.casinoConstants.categories = data.items;
        return data;
    }

    setBrojNotifikacija(x) {
        this.setState({ brojNotifikacija: x });
    }

    getNotifikacije() {
        if (this.state.user && !document.hidden && !casino.config.fromNativeApp) {
            var promises = Promise.all([casino.repos.notifikacijeRepo.list(true, true)]);
            this.dataPromiseNotifikacije = casino.utils.makeCancelablePromise(promises);
            this.dataPromiseNotifikacije.promise.then(this.setNotifikacijeData, function (reason) { });
        } else if (!this.state.user && !document.hidden && !casino.config.fromNativeApp) {
            var promises = Promise.all([casino.repos.notifikacijeRepo.list(false, true)]);
            this.dataPromiseNotifikacije = casino.utils.makeCancelablePromise(promises);
            this.dataPromiseNotifikacije.promise.then(this.setNotifikacijeData, function (reason) { });
        }
    }

    setNotifikacijeData(data) {
        var [notifikacijeData] = data;
        var notifikacije = (notifikacijeData && Array.isArray(notifikacijeData.notifikacije))
            ? notifikacijeData.notifikacije
            : [];
        var story = (notifikacijeData && Array.isArray(notifikacijeData.story))
            ? notifikacijeData.story
            : [];

        this.setState({
            brojNotifikacija: notifikacije.filter(x => x.tipNotifikacije >= 100).length,
            notifikacije: notifikacije.filter(x => !x.jeNeprocitanaStara && !x.important),
            stories: story.length > 0,
            brojStorya: story.filter(x => x.tipNotifikacije >= 100).length,
            important: notifikacije.find(x => x.important) ? true : false
        });
    }

    setTabCategory(id) {
        this.setState({ tabCategoryId: id });
    }

    setActiveFilters(categories, providers, themes, specialFilters) {
        this.setState({
            filterSelectedCategories: categories,
            filterSelectedProviders: providers,
            filterSelectedThemes: themes,
            filterSelectedSpecialFilters: specialFilters
        });
    }

    filterGames(games) {
        var filteredGames = [];
        if (games) {
            if (this.state.filterSelectedCategories.length > 0 || this.state.filterSelectedProviders.length > 0 || this.state.filterSelectedThemes.length > 0 || this.state.filterSelectedSpecialFilters?.length > 0) {
                if (this.state.filterSelectedCategories.length > 0) {
                    games = games.filter(x => x.kt && this.state.filterSelectedCategories.filter(cat => Object.keys(x.kt).indexOf(cat.id.toString()) > -1).length > 0);
                }

                if (this.state.filterSelectedProviders.length > 0) {

                    games = games.filter(x => x.bID && this.state.filterSelectedProviders.filter(it => it == x.bID).length > 0);
                }
                if (this.state.tags && this.state.filterSelectedThemes.length > 0) {
                    games = games.filter(x => x.t && this.state.filterSelectedThemes.filter(it => Object.keys(x.t).find(y => this.state.tags[y] == it.tag)).length > 0);
                }

                if (this.state.filterSelectedSpecialFilters?.length > 0) {
                    this.state.filterSelectedSpecialFilters.forEach(type => {
                        //1 - Moje zadnje odigrano
                        if (type == 1 && this.state.user.zadnjeIgrano.length > 0) {
                            games = games.filter(game => this.state.user.zadnjeIgrano.indexOf(game.s) > -1);
                        }
                        //2 - Moje najomiljenije
                        if (type == 2 && this.state.user.najigranije.length > 0) {
                            games = games.filter(game => this.state.user.najigranije.indexOf(game.s) > -1);
                        }
                        //3 - Ekskluzivno
                        if (type == 3) {
                            games = games.filter(game => game.p && (game.p.indexOf("ex") != -1));
                        }
                        //4 - Najnovije
                        if (type == 4) {
                            games = games.filter(game => game.p && (game.p.indexOf("n") != -1));
                        }
                        //5 - Respin
                        if (type == 5) {
                            games = games.filter(game => game.p && (game.p.indexOf("re") != -1));
                        }
                        //6 - Megaways
                        if (type == 6) {
                            games = games.filter(game => game.p && (game.p.indexOf("mw") != -1));
                        }
                        //7 - Bonus Buy
                        if (type == 7) {
                            games = games.filter(game => game.p && (game.p.indexOf("bb") != -1));
                        }
                        //8 - Hold and Win
                        if (type == 8) {
                            games = games.filter(game => game.p && (game.p.indexOf("haw") != -1));
                        }
                        //Jackpot Cards
                        if (type == 9) {
                            games = games.filter(game => game.p && (game.p.indexOf("jc") != -1));
                        }
                        //Bell Link
                        if (type == 10) {
                            games = games.filter(game => game.p && (game.p.indexOf("bl") != -1));
                        }
                        //Golden Coins Link
                        if (type == 11) {
                            games = games.filter(game => game.p && (game.p.indexOf("gcl") != -1));
                        }
                        //Barlink
                        if (type == 12) {
                            games = games.filter(game => game.p && (game.p.indexOf("br") != -1));
                        }
                        //Jackpot Rain
                        if (type == 13) {
                            games = games.filter(game => game.p && (game.p.indexOf("jr") != -1));
                        }
                        //Egypt Quest
                        if (type == 14) {
                            games = games.filter(game => game.p && (game.p.indexOf("eq") != -1));
                        }
                        //Golden Nights Bonus
                        if (type == 15) {
                            games = games.filter(game => game.p && (game.p.indexOf("gnb") != -1));
                        }
                        //Red Hot Fire Pot
                        if (type == 16) {
                            games = games.filter(game => game.p && (game.p.indexOf("rhfp") != -1));
                        }
                        //Gameart Jackpot
                        if (type == 17) {
                            games = games.filter(game => game.p && (game.p.indexOf("gj") != -1));
                        }
                        //Clover Chance
                        if (type == 18) {
                            games = games.filter(game => game.p && (game.p.indexOf("cc") != -1));
                        }
                    });
                }

                filteredGames = games;
            }

            if (filteredGames.length > 1)
                filteredGames = filteredGames.sort(function (x, y) {
                    return x.kt['9'] > y.kt['9'] ? 1 : -1;
                });
        }
        this.setState({ filteredGames: filteredGames })
    }

    setHistoryFilters(filters) {
        this.setState({ historyFilters: filters });
    }

    render() {
        // dodamo djeci dodane stvari
        var extraParams = {
            showLoadingFn: this.showLoading,
            showMenuFn: this.showMenu,
            updateUserFn: this.updateUser,
            fetchUserFn: this.fetchUser,
            user: this.state.user,
            userChecked: this.state.userChecked,
            renderMenuFn: this.renderMenu,
            toggleSakrijIznosFn: this.toggleSakrijIznos,
            toggleFavoritGameFn: this.toggleFavoritGame,
            sakrijObavijestFn: this.sakrijObavijest,
            getHomePathFn: this.getHomePath,
            sakrijNovoBannerFn: this.sakrijNovoBanner,
            pozzitoStartedFn: this.pozzitoStarted,
            unpackGamesListFn: this.unpackGamesList,
            showSearchFn: this.showSearch,
            toggleMoreMenuFn: this.toggleMoreMenu,
            showPopUpFn: this.showPopUp,
            disablePopUpOutsideClickFn: this.disablePopUpOutsideClick,
            tags: this.state.tags,
            closeAndroidDlBannerFn: this.closeAndroidDlBanner,
            getNotifikacijeFn: this.getNotifikacije,
            disablePopUpBtnFn: this.disablePopUpBtn,
            saveCategoriesFn: this.saveCategories,
            showCookiePopUpFn: this.showCookiePopUp,
            autoShowRandomGameFn: this.autoShowRandomGame,
            refreshRandomGameFn: this.refreshRandomGame,
            setTabCategoryFn: this.setTabCategory,
            setActiveFiltersFn: this.setActiveFilters,
            filterGamesFn: this.filterGames,
            setHistoryFiltersFn: this.setHistoryFilters
        };

        if (this.props.type == "app") {
            return <BrowserRouter basename={this.getBaseName()}>
                <Route render={(route) => <div className={this.getMainClass(route)}>
                    <div className="background-red-iphone-fix tablet-hidden"></div>

                    {this.state.networkError && <NetworkError />}

                    <Pace showLoading={this.state.showLoading} />

                    <Menu {...this.state} {...this.props} {...extraParams} key="menu" />

                    {/* overlay kad se otvori menu */}
                    <div id="page-overlay" className={!casino.utils.getLocalStorageWithExpiry('android-dl-banner-is-closed') ? 'dwn-android' : ''} onClick={() => { this.showMenu(false); }} />

                    {/* overlay kad se otvori pop up */}
                    <div id="page-overlay-pop-up" onClick={() => { this.state.popUpCloseOnOutsideClick ? this.showPopUp(false) : undefined; }} />

                    <div id="content">
                        <Switch>
                            {/* home and game page  */}
                            <Route exact path="/" render={(route) =>
                                (<Home key="home-page" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} fetchJackpots={this.fetchJackpots} lazyLoadPageSize={40} lazyLoadOffset={256} />)} />
                            {/* download  page  */}
                            <Route path="/download" render={(route) =>
                                (<CasinoDownload key="casino-download-page"  {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* Providers page */}
                            <Route path="/provideri/game/:providerName/:gameName" render={(route) =>
                                (<Providers key="providers-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            <Route path="/provideri" render={(route) =>
                                (<Providers key="providers-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* Themes page with provider*/}
                            <Route path="/teme/game/:providerName/:gameName" render={(route) =>
                                (<Themes key="casino-theme-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            <Route path="/teme" render={(route) =>
                                (<Themes key="casino-theme-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* home and game page with provider  */}
                            <Route path="/game/:providerName/:gameName/info" render={(route) =>
                                (<GameInfo key="game-info-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* home and game page with provider  */}
                            <Route path="/game/:providerName/:gameName" render={(route) =>
                                (<Home key="home-page" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />
                            {/* home and game page  */}
                            <Route path="/game/:gameName" render={(route) =>
                                (<Home key="home-page" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />
                            {/* login page */}
                            <Route path="*/login" render={(route) =>
                                (<Login key="login-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* bonuses page */}
                            <Route path="*/account/bonuses" render={(route) =>
                                (<AccountBonuses key="account-bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* SuperKlub page */}
                            <Route path="*/account/superklub" render={(route) =>
                                (<AccountSuperKlub key="account-superklub-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* SuperSpin page */}
                            <Route path="*/account/superspin" render={(route) =>
                                (<AccountSuperSpin key="account-bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* SuperStory page */}
                            <Route path="*/super-story" render={(route) =>
                                (<SuperStory key="super-story-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* transactions page */}
                            <Route path="*/account/transactions" render={(route) =>
                                (<AccountTransactions key="account-transactions-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* account games page with game  */}
                            <Route path="*/account/games/playgame/:providerName/:gameName" render={(route) =>
                                (<AccountGames key="account-games-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* account free games page with game  */}
                            <Route path="*/account/free-games/playgame/:providerName/:gameName" render={(route) =>
                                (<AccountFreeGames key="account-free-games-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* games details page */}
                            <Route path="*/account/games/:providerId/:gameId/:roundId" render={(route) =>
                                (<AccountGameProviderDetails key="account-games-details-provider-details" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* games details page */}
                            <Route path="*/account/games/:providerId/:gameId" render={(route) =>
                                (<AccountGameDetails key="account-games-details-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* games page */}
                            <Route path="*/account/games" render={(route) =>
                                (<AccountGames key="account-games-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* free games page */}
                            <Route path="*/account/free-games" render={(route) =>
                                (<AccountFreeGames key="account-free-games-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* obavijesti page */}
                            <Route path="*/obavijesti/:obavijestID?" render={(route) =>
                                (<AccountObavijesti key="account-obavijesti-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* postavke privatnosti page */}
                            <Route path="*/account/privacy" render={(route) =>
                                (<PostavkePrivatnosti key="account-postavke-privatnosti-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* account page */}
                            <Route path="*/account" render={(route) =>
                                (<Account2 key="account-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* winners page with provider*/}
                            <Route path="/winners/game/:providerName/:gameName" render={(route) =>
                                (<Winners key="winners-page" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />
                            {/* winners page */}
                            <Route path="/winners/game/:gameName" render={(route) =>
                                (<Winners key="winners-page" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />
                            <Route path="/winners" render={(route) =>
                                (<Winners key="winners-page" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />

                            {/* bonuses page haloween with provider */}
                            <Redirect exact from='/bonuses/halloween/game/:providerName/:gameName' to='/promotions/halloween/game/:providerName/:gameName' />
                            <Route path="/promotions/halloween/game/:providerName/:gameName" render={(route) =>
                                (<BonusesHalloween key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* bonuses page */}
                            <Redirect exact from='/bonuses/halloween/game/:gameName' to='/promotions/halloween/game/:gameName' />
                            <Route path="/promotions/halloween/game/:gameName" render={(route) =>
                                (<BonusesHalloween key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* bonuses page - valentinovo with provider */}
                            <Redirect exact from='/bonuses/valentinovo/game/:providerName/:gameName' to='/promotions/valentinovo/game/:providerName/:gameName' />
                            <Route path="/promotions/valentinovo/game/:providerName/:gameName" render={(route) =>
                                (<BonusesValentinovo key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* bonuses page - valentinovo */}
                            <Redirect exact from='/bonuses/valentinovo/game/:gameName' to='/promotions/valentinovo/game/:gameName' />
                            <Route path="/promotions/valentinovo/game/:gameName" render={(route) =>
                                (<BonusesValentinovo key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* bonuses page - first deposit game with provider */}
                            <Redirect exact from='/bonuses/first-deposit/game/:providerName/:gameName' to='/promotions/first-deposit/game/:providerName/:gameName' />
                            <Route path="/promotions/first-deposit/game/:providerName/:gameName" render={(route) =>
                                (<FirstDepositBonus key="first-deposit-bonuses-page-game" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* bonuses page - casino maraton game with provider */}
                            <Redirect exact from='/bonuses/casino-maraton/game/:providerName/:gameName' to='/promotions/casino-maraton/game/:providerName/:gameName' />
                            <Route path="/promotions/casino-maraton/game/:providerName/:gameName" render={(route) =>
                                (<BonusesCasinoMaraton key="casino-maraton-bonuses-page-game" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />

                            {/* bonuses page - first deposit game */}
                            <Redirect exact from='/bonuses/first-deposit/game/:gameName' to='/promotions/first-deposit/game/:gameName' />
                            <Route path="/promotions/first-deposit/game/:gameName" render={(route) =>
                                (<FirstDepositBonus key="first-deposit-bonuses-page-game" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/first-deposit' to='/promotions/first-deposit' />
                            <Route path="/promotions/first-deposit" render={(route) =>
                                (<FirstDepositBonus key="first-deposit-bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/promotions/drops-and-wins" render={(route) =>
                                (<DropsAndWins key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* SpinsSplash Promocija page*/}
                            <Route path="/promotions/spins-splash" render={(route) =>
                                (<SpinsSplash key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* ZimskaSuperBomba Promocija page*/}
                            <Route path="/promotions/zimska-super-bomba" render={(route) =>
                                (<ZimskaSuperBomba key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* MjesecnaSuperBomba Promocija page*/}
                            <Route path="/promotions/mjesecna-super-bomba" render={(route) =>
                                (<MjesecnaSuperBomba key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* Superklub Promocija page*/}
                            <Route path="/promotions/superklub" render={(route) =>
                                (<SuperKlub key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* SuperAvantura page with provider*/}
                            <Route path="/promotions/super-avantura/game/:providerName/:gameName" render={(route) =>
                                (<BonusesSuperAvantura key="super-avantura-page-game" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />

                            <Route path="/promotions/super-avantura" render={(route) =>
                                (<BonusesSuperAvantura key="super-avantura-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/happy-hour' to='/promotions/happy-hour' />
                            <Route path="/promotions/happy-hour" render={(route) =>
                                (<BonusesHappyHour key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/last-man-standing' to='/promotions/last-man-standing' />
                            <Route path="/promotions/last-man-standing" render={(route) =>
                                (<BonusesLastManStanding key="lms-bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/uskrsni-bonus-maraton' to='/promotions/uskrsni-bonus-maraton' />
                            <Route path="/promotions/uskrsni-bonus-maraton" render={(route) =>
                                (<Bonuses3 key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/valentinovo' to='/promotions/valentinovo' />
                            <Route path="/promotions/valentinovo" render={(route) =>
                                (<BonusesValentinovo key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/halloween' to='/promotions/halloween' />
                            <Route path="/promotions/halloween" render={(route) =>
                                (<BonusesHalloween key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/game/:gameName' to='/promotions/game/:gameName' />
                            <Route path="/promotions/game/:gameName" render={(route) =>
                                (<Bonuses key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/casino-maraton' to='/promotions/casino-maraton' />
                            <Route path="/promotions/casino-maraton" render={(route) =>
                                (<BonusesCasinoMaraton key="casino-maraton-bonuses-page-game" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />

                            <Route path="/promotions/casino-superskok/:kampanja/game/:providerName/:gameName" render={(route) =>
                                (<BonusesCasinoSuperskok key="bonuses-page-superskok" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/promotions/casino-superskok/:kampanja" render={(route) =>
                                (<BonusesCasinoSuperskok key="bonuses-page-superskok" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/casino-superskok' to='/promotions/casino-superskok' />
                            <Route path="/promotions/casino-superskok"
                                render={() => {
                                    return (
                                        window.location.href.indexOf('evoplay') == -1 ?
                                            <BonusesCasinoSuperskok key="bonuses-page-superskok" {...extraParams} {...this.state} {...this.props} route={route} /> :
                                            <Redirect to="/promotions/casino-superskok/evoplay" />
                                    )
                                }} />

                            <Route path="/promotions/casino-superbomba/:kampanja/game/:providerName/:gameName" render={(route) =>
                                (<BonusesCasinoSuperbomba key="bonuses-page-superbomba" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/promotions/casino-superbomba/:kampanja" render={(route) =>
                                (<BonusesCasinoSuperbomba key="bonuses-page-superbomba" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/casino-superbomba' to='/promotions/casino-superbomba' />
                            <Route path="/promotions/casino-superbomba" render={(route) =>
                                (<BonusesCasinoSuperbomba key="bonuses-page-superbomba" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/promotions/superkisa" render={(route) =>
                                (<BonusesCasinoSuperKisa key="bonuses-page-superkisa" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* Cashback page with provider*/}
                            <Route path="/promotions/cashback/game/:providerName/:gameName" render={(route) =>
                                (<BonusesCasinoCashback key="bonuses-page-cashback" {...extraParams} {...this.state} {...this.props} route={route} brands={this.state.brands} />)} />

                            <Route path="/promotions/cashback" render={(route) =>
                                (<BonusesCasinoCashback key="bonuses-page-cashback" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/promotions/casino-sprint/game/:providerName/:gameName" render={(route) =>
                                (<BonusesCasinoSprint key="bonuses-page-sprint" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/promotions/casino-sprint/:promotion" render={(route) =>
                                (<BonusesCasinoSprint key="bonuses-page-sprint" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses/casino-sprint' to='/promotions/casino-sprint' />
                            <Route path="/promotions/casino-sprint" render={(route) =>
                                (<BonusesCasinoSprint key="bonuses-page-sprint" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Redirect exact from='/bonuses' to='/promotions' />
                            <Route path="/promotions" render={(route) =>
                                (<Bonuses key="bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - faq */}
                            <Route exact path="/pravila/faq" render={(route) =>
                                (<Faq key="faq" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - opca pravila */}
                            <Route exact path="/pravila/opca-pravila" render={(route) =>
                                (<OpcaPravila key="opca-pravila" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - odgovorno igranje */}
                            <Route exact path="/pravila/odgovorno-igranje" render={(route) =>
                                (<OdgovornoIgranje key="odgovorno-igranje" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - zaštita privatnosti */}
                            <Route exact path="/pravila/zastita-privatnosti" render={(route) =>
                                (<ZastitaPrivatnosti key="zastita-privatnosti" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - politika kolacica */}
                            <Route exact path="/pravila/politika-kolacica" render={(route) =>
                                (<PolitikaKolacica key="politika-kolacica" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - pravila superkluba */}
                            <Route exact path="/pravila/pravila-superkluba" render={(route) =>
                                (<PravilaSuperkluba key="pravila-superkluba" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - pravila superspina */}
                            <Route exact path="/pravila/pravila-superspina" render={(route) =>
                                (<PravilaSuperspina key="pravila-superspina" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - obavijest o obradi osobnih podataka */}
                            <Route exact path="/pravila/obavijest-o-obradi-osobnih-podataka" render={(route) =>
                                (<ObavijestOObradiOsobnihPodataka key="obavijest-o-obradi-osobnih-podataka" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - 18 plus */}
                            <Route exact path="/pravila/plus18" render={(route) =>
                                (<Plus18 key="plus18" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* pravila page - o tvrtki */}
                            {/*<Route exact path="/pravila/certifikati" render={(route) =>*/}
                            {/*    (<Certifikati key="certifikati" {...extraParams} {...this.state} {...this.props} route={route} />)} />*/}

                            {/* pravila page - o tvrtki */}
                            <Route exact path="/pravila/o-tvrtki" render={(route) =>
                                (<Tvrtki key="o-tvrtki" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* marketing landing pages */}
                            <Route path="/info/:landingPage?" render={(route) =>
                                (<InfoLanding key="landing-page"  {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* kontakt page */}
                            <Route exact path="/kontakt" render={(route) =>
                                (<KontaktPage key="kontakt" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* popis igara - game page */}
                            <Route path="/popis-igara/game/:providerName/:gameName" render={(route) =>
                                (<PopisIgara key="popis-igara" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* popis igara */}
                            <Route exact path="/popis-igara" render={(route) =>
                                (<PopisIgara key="popis-igara" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* relaod page */}
                            <Route path="/reload" render={(route) =>
                                (<ReloadBonus key="reload-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* POKER  */}
                            <Route exact path="/poker" render={(route) =>
                                (<PokerHome key="poker-home-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker download */}
                            <Route path="/poker/download" render={(route) =>
                                (<PokerDownload key="poker-download-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker live */}
                            <Route exact path="/poker/live" render={(route) =>
                                (<PokerLive key="poker-live-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker room */}
                            <Route path="/poker/live/room" render={(route) =>
                                (<PokerRoom key="poker-room-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker classic */}
                            <Route path="/poker/live/classic" render={(route) =>
                                (<PokerClassic key="poker-classic-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker classic mini */}
                            <Route path="/poker/live/classic-mini" render={(route) =>
                                (<PokerClassicMini key="poker-classic-mini-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker room */}
                            <Route path="/poker/live/festival" render={(route) =>
                                (<PokerFestival key="poker-festival-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker turniri */}
                            <Route path="/poker/tournaments" render={(route) =>
                                (<PokerTournaments key="poker-tournaments-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* poker bonusi */}
                            <Redirect exact from='/poker/bonuses/:bonus/:action?' to='/poker/promotions/:bonus/:action?' />
                            <Redirect exact from='/poker/bonuses' to='/poker/promotions' />
                            <Redirect exact from='/poker/prvenstvohrvatske' to='/poker/promotions/prvenstvo-hrvatske' />
                            <Route path="/poker/promotions" render={(route) =>
                                (<PokerBonuses key="poker-bonuses-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* user info page - pranje novca*/}
                            <Route path="*/info/pranje-novca" render={(route) =>
                                (<InfoPranjeNovca key="page-info-page-pranje-novca" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* user info page */}
                            <Route path="*/page-info" render={(route) =>
                                (<Info key="page-info-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                            {/* jackpot page */}
                            <Route path="/jackpot" render={(route) =>
                                (<Jackpot key="jackpot-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* egypt quest */}
                            <Route path="*/egypt-quest" render={(route) =>
                                (<EgyptQuest key="egypt-quest-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* casino-utrka - igra */}
                            <Route path="/casino-utrke/:raceId/game/:providerName/:gameName" render={(route) =>
                                (<CasinoUtrka key="casino-utrka" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* casino-utrka */}
                            <Route path="/casino-utrke/:raceId" render={(route) =>
                                (<CasinoUtrka key="casino-utrka" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* casino-utrke - igra */}
                            <Route path="/casino-utrke/game/:providerName/:gameName" render={(route) =>
                                (<CasinoUtrka key="casino-utrke" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* casino-utrke */}
                            <Route path="/casino-utrke" render={(route) =>
                                (<CasinoUtrke key="casino-utrke" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/all-promotions/game/:providerName/:gameName" render={(route) =>
                                (<AllPromotions key="all-promotions" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            <Route path="/all-promotions" render={(route) =>
                                (<AllPromotions key="all-promotions" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* empty blank page for chat on android */}
                            <Route path="*/chat" render={(route) =>
                                (<Chat key="chat" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* cookie policy */}
                            <Route path="/cookie-policy" render={(route) =>
                                (<CookiePolicy key="cookie-policy" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* vip page */}
                            <Route path="/vip" render={(route) =>
                                (<VipPage key="vip" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* izbor theme (dark/light) page */}
                            <Route path="/promjena-teme" render={(route) =>
                                (<ThemeSelection key="account-theme-selection-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* super predah */}
                            <Route path="/super-predah" render={(route) =>
                                (<SuperPredah key="super-predah" {...extraParams} {...this.state} {...this.props} route={route} />)} />

                            {/* 404 not found */}
                            <Route render={(route) =>
                                (<NotFound key="404-page" {...extraParams} {...this.state} {...this.props} route={route} />)} />
                        </Switch>
                    </div>

                    {/* Search overlay */}
                    {!casino.config.fromNativeApp && <SearchOverlay {...this.state} {...extraParams} />}

                    {/* More menu - full screen */}
                    {!casino.config.fromNativeApp && <MoreMenu {...this.state} {...extraParams} />}

                    {/* Bottom navigation bar */}
                    {!casino.config.fromNativeApp && !window.location.pathname.includes('/super-story') && <BottomNavigationBar {...this.state} {...extraParams} />}

                    {/* footer*/}
                    {!casino.config.fromNativeApp && !window.location.pathname.includes('/super-story') && <Route render={(route) => <Footer {...extraParams} {...this.state} {...this.props} route={route} />} />}

                    {!casino.config.fromNativeApp && <PrekiniSamoiskljucenje {...this.state} {...extraParams}></PrekiniSamoiskljucenje>}
                    {!casino.config.fromNativeApp && <Notifikacija {...this.state} {...extraParams} brands={this.state.brands}></Notifikacija>}
                    {!casino.config.fromNativeApp && <Obavijest {...this.state} {...extraParams}></Obavijest>}

                    <PopUpInfo {...this.state}  {...extraParams}  {...this.props} route={route} />
                    {this.state.showCookiePopUp && !casino.config.fromNativeApp && <CookiePopUp {...this.state}  {...extraParams}  {...this.props} />}
                </div>
                } />
            </BrowserRouter>
        } else if (this.props.type == "play") {
            return <BrowserRouter>
                {this.state.userChecked &&
                    <WebSocketProvider jeTester={this.state.user.jeTester}>
                        <InGameWidget {...this.state} {...extraParams}  {...this.props} />
                    </WebSocketProvider>
                }
                <PopUpInfo {...this.state} {...extraParams}  {...this.props} />
                {!casino.config.fromNativeApp && <Notifikacija {...this.state} {...extraParams} brands={this.state.brands}></Notifikacija>}
            </BrowserRouter>
        }
    }
};

if (document.getElementById('app'))
    ReactDOM.render(<App type='app' />, document.getElementById('app'));

if (document.getElementById('app-play'))
    ReactDOM.render(<App type='play' />, document.getElementById('app-play'));